/**
 * Search Modal Functionality
 *
 * Handles opening/closing the search modal with WCAG compliance:
 * - Proper ARIA attributes
 * - Keyboard navigation (ESC to close)
 * - Focus management
 * - Body scroll lock when modal is open
 */

( function() {
	'use strict';

	// Wait for DOM to be ready
	function initSearchModal() {
		const searchToggle = document.querySelector( '.search-toggle' );
		const searchModal = document.getElementById( 'search-modal' );
		const searchModalClose = document.getElementById( 'search-modal-close' );
		const searchInput = document.getElementById( 'search-input' );
		const body = document.body;

		// Return early if elements don't exist
		if ( ! searchToggle || ! searchModal || ! searchModalClose || ! searchInput ) {
			return;
		}

		// Store the element that had focus before opening modal
		let previousActiveElement = null;

		// Open search modal
		const openSearchModal = () => {
			searchModal.classList.remove( 'hidden' );
			searchModal.setAttribute( 'aria-hidden', 'false' );
			searchToggle.setAttribute( 'aria-expanded', 'true' );
			
			// Store the element that had focus
			previousActiveElement = document.activeElement;
			
			// Prevent body scroll
			body.style.overflow = 'hidden';
			
			// Focus the search input
			setTimeout( () => {
				searchInput.focus();
			}, 100 );
		};

		// Close search modal
		const closeSearchModal = () => {
			searchModal.classList.add( 'hidden' );
			searchModal.setAttribute( 'aria-hidden', 'true' );
			searchToggle.setAttribute( 'aria-expanded', 'false' );
			
			// Restore body scroll
			body.style.overflow = '';
			
			// Return focus to the toggle button
			if ( previousActiveElement ) {
				previousActiveElement.focus();
				previousActiveElement = null;
			}
		};

		// Handle ESC key to close modal
		const handleEscapeKey = ( event ) => {
			if ( event.key === 'Escape' && searchModal.getAttribute( 'aria-hidden' ) === 'false' ) {
				closeSearchModal();
			}
		};

		// Toggle modal on button click
		searchToggle.addEventListener( 'click', function( event ) {
			event.preventDefault();
			event.stopPropagation();
			
			if ( searchModal.getAttribute( 'aria-hidden' ) === 'true' ) {
				openSearchModal();
			} else {
				closeSearchModal();
			}
		} );

		// Close modal on close button click
		searchModalClose.addEventListener( 'click', function( event ) {
			event.preventDefault();
			event.stopPropagation();
			closeSearchModal();
		} );

		// Close modal when clicking outside (on backdrop)
		searchModal.addEventListener( 'click', function( event ) {
			// If clicking directly on the modal backdrop (not on a child), close it
			if ( event.target === searchModal ) {
				closeSearchModal();
			}
		} );

		// Prevent modal from closing when clicking inside the modal content
		const modalContent = searchModal.querySelector( '.bg-white' );
		if ( modalContent ) {
			modalContent.addEventListener( 'click', function( event ) {
				event.stopPropagation();
			} );
		}

		// Handle ESC key
		document.addEventListener( 'keydown', handleEscapeKey );

		// Handle keyboard navigation (Enter/Space on toggle)
		searchToggle.addEventListener( 'keydown', function( event ) {
			if ( event.key === 'Enter' || event.key === ' ' ) {
				event.preventDefault();
				if ( searchModal.getAttribute( 'aria-hidden' ) === 'true' ) {
					openSearchModal();
				} else {
					closeSearchModal();
				}
			}
		} );

		// Close modal on window resize (optional - can be removed if not needed)
		window.addEventListener( 'resize', function() {
			if ( searchModal.getAttribute( 'aria-hidden' ) === 'false' ) {
				// Optionally close on resize, or keep it open
				// closeSearchModal();
			}
		} );
	}

	// Initialize when DOM is ready
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initSearchModal );
	} else {
		// DOM is already ready
		initSearchModal();
	}
}() );

